import IDValidator from 'id-validator';

const idValidator = new IDValidator();

/** 校验身份证号码 */
export function idValid(value, errorMsg) {
  if (!value || idValidator.isValid(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error(errorMsg));
}

/** 校验社会信用代码 */
export function creditCodeValid(value, errorMsg) {
  if (!value) {
    return Promise.resolve();
  }
  if (/^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error(errorMsg));
}

/** 校验手机号码 */
export function phoneValid(value, errorMsg) {
  if (!value) {
    return Promise.resolve();
  }
  if (/^1[3-9][0-9]{9}$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error(errorMsg));
}

/** 校验验证码 */
export function codeValid(value, errorMsg) {
  if (!value) {
    return Promise.resolve();
  }
  if (/^[0-9]{6}$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error(errorMsg));
}

/** 自定义正则校验 */
export function customPatternValid(regexp) {
  return function(value, errorMsg) {
    if (!value) {
      return Promise.resolve();
    }
    if (regexp.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(errorMsg));
  }
}
